import { useState } from 'react';
import convertToSuperscript from '../../utils/converToSuperscript';

import styles from './styles.module.scss';

const Results = ({ section, selectedAccessories, t }) => {
  const [toggledAccessory, setToggledAccessory] = useState(null);

  const sectionAccessories = selectedAccessories.filter(
    (accessory) => accessory.room === section.key
  );

  const handleToggle = (accessory) => {
    if (toggledAccessory === accessory) {
      setToggledAccessory(null);
      return;
    }
    setToggledAccessory(accessory);
  };

  return (
    <>
      {/* mobile */}
      <div className={styles.sectionMobile}>
        <h3>{t(section.title)}</h3>
        {sectionAccessories.map((accessory) => (
          <div className={styles.solution} key={accessory.name}>
            <div className={styles.solution__initial}>
              <h5 className={styles.solution__name}>{t(accessory.name)}</h5>
              <button
                className={`${styles.solution__expandButton} ${
                  toggledAccessory === accessory
                    ? styles['solution__expandButton--expanded']
                    : ''
                }`}
                onClick={() => handleToggle(accessory)}
              ></button>
            </div>
            {toggledAccessory === accessory && (
              <div className={styles.solution__expanded}>
                <div>
                  <label>{t('tool_ui.final.category_description')}</label>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: convertToSuperscript(accessory.description),
                    }}
                  ></p>
                </div>
                {accessory.features[0] && (
                  <div>
                    <label>{t('tool_ui.final.category_benefits')}</label>

                    <ul>
                      {accessory.features.map((feature, index) =>
                        feature ? (
                          <li
                            key={index}
                            className={styles.solution__expandedFeature}
                          >
                            <span></span>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: convertToSuperscript(feature),
                              }}
                            ></p>
                          </li>
                        ) : null
                      )}
                    </ul>
                  </div>
                )}
                <div>
                  <label>{t('tool_ui.final.category_recommended')}</label>
                  {accessory.recommended_name && (
                    <p>
                      {t(accessory.recommended_name)}{' '}
                      {accessory.powered_by && (
                        <span>
                          {accessory.powered_by === 'MULTIPLE' ? ' ,' : ''}
                          {t('tool_ui.general.poweredby')}{' '}
                        </span>
                      )}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* desktop / tablet */}
      <div className={styles.sectionDesktop}>
        <div className={styles.sectionDesktop__header}>
          <img
            src={`${process.env.PUBLIC_URL}/images_iax/icons/${section.key}.svg`}
            alt={section}
          />
          <h3>{t(section.title)}</h3>
        </div>
        <table className={styles.resultsTable}>
          <thead>
            <tr>
              <th>
                <h6>{t('tool_ui.final.category_solution')}</h6>
              </th>
              <th>
                <h6>{t('tool_ui.final.category_description')}</h6>
              </th>
              <th>
                <h6>{t('tool_ui.final.category_benefits')}</h6>
              </th>
              <th>
                <h6>{t('tool_ui.final.category_recommended')}</h6>
              </th>
            </tr>
          </thead>
          <tbody>
            {sectionAccessories.map((accessory) => (
              <tr key={accessory.name}>
                <td className={styles.resultsTable__solution}>
                  <h5>{t(accessory.name)}</h5>
                </td>
                <td>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: convertToSuperscript(accessory.description),
                    }}
                  ></p>
                </td>
                <td>
                  <ul className={styles.resultsTable__features}>
                    {accessory.features.map((feature, index) =>
                      feature ? (
                        <li key={index}>
                          <span></span>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: convertToSuperscript(feature),
                            }}
                          ></p>
                        </li>
                      ) : null
                    )}
                  </ul>
                </td>
                <td>
                  {accessory.recommended_name && (
                    <p>
                      {t(accessory.recommended_name)}
                      {accessory.powered_by && (
                        <span>
                          {accessory.powered_by === 'MULTI' ? ', ' : ' '}
                          {t('tool_ui.general.poweredby')}{' '}
                        </span>
                      )}
                    </p>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Results;
